<!-- eslint-disable -->
<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://' v-if='params')
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_category_of_words') }}
                .form__field-body
                    cs-multiselect(
                        :multiple='false',
                        :options='classes',
                        :show-labels='false',
                        :allow-empty='false',
                        track-by='name',
                        label='name',
                        placeholder="",
                        v-model='selectedClass',
                        @select='params.class = $event.value'
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
                .form__field-body.form-container__select-examples
                    cs-spin-input(
                        :value="params.amountOfExamples",
                        :min="1",
                        :max="999",
                        :disabled="params && params.infinityAmountOfExamples",
                        @increase="increaseExamples",
                        @decrease="decreaseExamples",
                        @input="params.amountOfExamples = $event",
                    )
                    .form-container__select-infinity-mode(v-if="gameMode && gameMode === 'free-game'")
                        cs-checkbox#infinityAmountOfExamples.form-container__checkbox(
                            v-model="params.infinityAmountOfExamples"
                            :checked="params && params.infinityAmountOfExamples"
                        )
                        svg-icon.form-container__svg-icon(name="infinity" :aria-hidden="true" size="big")
            divider
            slot(name='parameters')
            slot(name='help')
            .form__buttons(v-if='!usersIds')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                template(v-if="gameMode === 'free-game'")
                    cs-button.form__button(color="blue", :disabled="disableButton", @click='saveGameMode')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else='')
                    cs-button.form__button(color="blue", :disabled="disableButton", @click='saveGame')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
            .form__buttons(v-else='')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                cs-button.form__button(color="blue", :disabled="disableButton", @click='saveGame')
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    /*eslint-disable*/
    import GameFormMixin from '../../../utils/trainer/GameFormMixin';
    import TrainerGames from '../../../config/trainer';
    import { getInitParameters } from '@/utils/trainer/getInitParameters';
    import { mapState } from 'vuex';
    import _ from 'lodash';
    import multiplayerFormMixin from '../../../utils/multiplayer/formMixin';

    export default {
        props: [
            'slug',
            'courseType',
            'id',
            'usersIds',
            'homeworkId',
            'gameMode',
            'levelAnswerDuration',
            'gameId',
            'generatorSettings',
            'generatorGameIndex',
        ],
        mixins: [GameFormMixin, multiplayerFormMixin],
        data() {
            return {
                params: null,
                selectedClass: null,
                classes: [
                    {
                        name: this.$i18n.t('trainer.trainer_gameFormSetting_class_1'),
                        value: 1,
                    },
                    {
                        name: this.$i18n.t('trainer.trainer_gameFormSetting_class_2'),
                        value: 2,
                    },
                    {
                        name: this.$i18n.t('trainer.trainer_gameFormSetting_class_3'),
                        value: 3,
                    },
                ],
            };
        },
        mounted() {
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = _.cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(
                        this,
                        'params',
                        getInitParameters({
                            slug: this.slug,
                            parameters: {
                                default: _.cloneDeep(this.gamesParameters[this.slug]),
                            },
                        })
                    );
                } else {
                    this.params = _.cloneDeep(TrainerGames.games).find(
                        item => item.slug === this.slug
                    ).parameters.default;
                }
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
            this.selectedClass = _.find(this.classes, { value: this.params.class });
        },
        updated() {
            this.selectedClass = _.find(this.classes, { value: this.params.class });
        },
        methods: {
            decreaseExamples() {
                if (this.params.amountOfExamples !== 1) {
                    this.params.amountOfExamples -= 1;
                }
            },
            increaseExamples() {
                this.params.amountOfExamples += 1;
            },
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user,
            }),
            disableButton() {
                return !this.params.infinityAmountOfExamples && !this.params.amountOfExamples;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }
    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: 0.5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }

    .form-container__select-examples {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        @media screen and (min-width: 700px) {
            flex-direction: row;
            align-items: center;
        }
    }

    .form-container__select-infinity-mode {
        display: flex;
        align-items: center;
        margin-top: 20px;
        @media screen and (min-width: 700px) {
            margin-top: 0;
        }
    }

    .form-container__checkbox {
        margin-left: 30px;
    }

    .form-container__svg-icon {
        opacity: 0.7;
        margin: 0 10px 10px 0;
    }
</style>
